import { render, staticRenderFns } from "./RejectInvoiceConfirmationModal.vue?vue&type=template&id=2e4f7b72&"
import script from "./RejectInvoiceConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./RejectInvoiceConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports